module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAFCAYAAACjKgd3AAAAg0lEQVQYlZXPMQ5BQRSF4e+JxDbECiQKhZgdMNHaBIlEpdOpZgs6rS2oNBag1VJLVGTiSXTGX93c5Pw5p5odV77ZH+ZTnGNIJwWk/lrTO9jCGAs8MSgRfKjam9soC9Gpnxdc/5LkOXWTCZa4YxhDyo1+kuc08hFDesSQduhhi25xDbwAkdgeKrGTWxUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/syb.png
// module id = viG+
// module chunks = 1